import React, {ComponentProps, FC} from 'react';

import {Colors, Text} from '@optimaxdev/design-system';

import {OrderDetailsAddressType} from 'types/orderDetailsTypes';

const getCommonTextProps = (isDesktop: boolean): ComponentProps<typeof Text> => ({
    as: 'p',
    color: Colors.limedSpruce,
    lineHeight: isDesktop ? '26px' : 'auto',
    size: isDesktop ? '16px' : '14px',
});

const getCommonTitleProps = (isDesktop: boolean): ComponentProps<typeof Text> => ({
    as: 'p',
    bold: true,
    color: Colors.limedSpruce,
    lineHeight: isDesktop ? '24px' : '20px',
    margin: '0 0 8px',
    size: isDesktop ? '16px' : '14px',
});

/**
 * Shipping address for success page
 */
export const ShippingAddress: FC<{
    isDesktop: boolean;
    isSameAddresses: boolean;
    shippingAddress: OrderDetailsAddressType;
    shippingMethod: string;
}> = ({isDesktop, isSameAddresses, shippingAddress, shippingMethod}) => (
    <>
        <div>
            <Text {...getCommonTitleProps(isDesktop)}>
                {isSameAddresses && !isDesktop ? 'Shipping & Billing Address' : 'Shipping Address'}
            </Text>
            <Text {...getCommonTextProps(isDesktop)}>
                {shippingAddress.firstname} {shippingAddress.lastname}
            </Text>
            <Text {...getCommonTextProps(isDesktop)}>
                {shippingAddress.street}, {shippingAddress.city},
            </Text>
            <Text {...getCommonTextProps(isDesktop)}>
                {shippingAddress.region}, {shippingAddress.postcode}, {shippingAddress.country_full}
            </Text>
            <Text {...getCommonTextProps(isDesktop)}>{shippingAddress.telephone}</Text>
        </div>
        <div>
            <Text {...getCommonTitleProps(isDesktop)}>Shipping Method:</Text>
            <Text {...getCommonTextProps(isDesktop)}>{shippingMethod}</Text>
        </div>
    </>
);
